import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/img/icon/data-empty.svg'


const _hoisted_1 = { class: "container-no-data" }
const _hoisted_2 = { class: "wrap-no-data" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1)




export default /*#__PURE__*/_defineComponent({
  __name: 'EmptyState',
  props: {
  textNoData: {
    type: String,
    default: 'Data belum ada, silahkan tambah untuk mengisi data'
  }
},
  setup(__props) {




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("p", null, _toDisplayString(__props.textNoData), 1)
    ])
  ]))
}
}

})